import { useCallback } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { NPSDReportsGrid } from '@/components/npsd/NPSDReportsGrid';

interface NPSDClientHistoryProps {
  reports: any[];
  clientId?: number | string | null;
  title?: string;
  onViewReport?: (reportId: any) => void;
}

export function NPSDClientHistory({
  reports = [],
  clientId,
  title = 'Reports Involving Client',
  onViewReport,
}: NPSDClientHistoryProps) {
  const { theme } = useTheme();

  const handleViewReport = useCallback((reportId: any) => {
    onViewReport?.(reportId);
  }, [onViewReport]);

  return (
    <div className={`npsd-client-history ${theme}`}>
      <NPSDReportsGrid
        reports={reports}
        title={title}
        entityType="client"
        sortable={true}
        onViewReport={handleViewReport}
      />
    </div>
  );
}

(window as any).NPSDClientHistoryReact = NPSDClientHistory;
